/**
 * Created by fgallucci on 17/06/2020.
 */
import React from 'react'
import { isNull } from 'lodash'
import { Redirect } from 'react-router'
import useRedirect from 'services/auth/useRedirect'

function Home({ fallbackRedirectPath }) {
  const redirect = useRedirect({ fallbackPath: fallbackRedirectPath })

  if (!isNull(redirect) && redirect !== '/home') {
    return <Redirect to={redirect} />
  }

  return null
}

export default Home
